function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { forwardRef } from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
function RawInput(_param, ref) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", _extends({}, props, {
        ref: ref,
        className: twMerge(cx("block w-full py-3 text-body.base leading-relaxed", "border-b border-b-fg-default bg-bg-default", "focus:outline-none", "placeholder:opacity-100 placeholder:text-fg-inbetween", className))
    }));
}
export var Input = /*#__PURE__*/ forwardRef(RawInput);

//# sourceMappingURL=Input.js.map